module.exports = __webpack_public_path__ + "img/trainingRoomlistNull.efc7f8c4.png";